import { PinCheckbox} from "./PinCheckbox";

export default PinCheckbox;
